import { FC } from 'react'
import {
    BookingForm,
    DocumentsForm,
    GenericInfoForm,
    PaymentForm,
} from 'features/Booking/ui/components'
import { BookingStepType } from 'features/Booking/model/slices'
import { Tab, Tabs } from 'shared/components/Tabs'
import { Accordion } from 'shared/components/Accordion'

interface ITabs {
    activeTabIndex: number
    disabledTabIndex?: number
    onChangeTab: (tabIndex: number) => void
    AccordionState: Record<
        BookingStepType,
        {
            isOpen?: boolean | undefined
            isDisabled: boolean
            title: string
            handleOpen: (isOpen: boolean) => void
        }
    >
    isEdit: boolean
    isPreview: boolean
}

export const FormTabs: FC<ITabs> = ({
    activeTabIndex,
    disabledTabIndex,
    onChangeTab,
    AccordionState,
    isEdit,
    isPreview,
}) => (
    <Tabs
        activeTabIndex={activeTabIndex}
        disabledTabIndex={disabledTabIndex}
        onTabChange={onChangeTab}
        disableAutoTabChange
    >
        <Tab label='Физическое лицо'>
            <Accordion
                isOpen={AccordionState.generalInfo.isOpen}
                title={AccordionState.generalInfo.title}
                isOpenByDefault={!isEdit}
                handleOpen={AccordionState.generalInfo.handleOpen}
            >
                <GenericInfoForm isPreview={isPreview} />
            </Accordion>
            <Accordion
                isOpen={AccordionState.booking.isOpen}
                title={AccordionState.booking.title}
                disabled={AccordionState.booking.isDisabled}
                handleOpen={AccordionState.booking.handleOpen}
                isOpenByDefault={isEdit}
            >
                <BookingForm isPreview={isPreview} />
            </Accordion>
            <Accordion
                isOpen={AccordionState.payment.isOpen}
                title={AccordionState.payment.title}
                disabled={AccordionState.payment.isDisabled}
                handleOpen={AccordionState.payment.handleOpen}
            >
                <PaymentForm isPreview={isPreview} />
            </Accordion>
            <Accordion
                isOpen={AccordionState.documents.isOpen}
                title={AccordionState.documents.title}
                disabled={AccordionState.documents.isDisabled}
                handleOpen={AccordionState.documents.handleOpen}
            >
                <DocumentsForm isPreview={isPreview} />
            </Accordion>
        </Tab>
        <Tab label='Юридическое лицо'>
            <Accordion
                isOpen={AccordionState.generalInfo.isOpen}
                title={AccordionState.generalInfo.title}
                isOpenByDefault={!isEdit}
                handleOpen={AccordionState.generalInfo.handleOpen}
            >
                <GenericInfoForm isPreview={isPreview} isCompany />
            </Accordion>
            <Accordion
                isOpen={AccordionState.booking.isOpen}
                title={AccordionState.booking.title}
                isOpenByDefault={isEdit}
                disabled={AccordionState.booking.isDisabled}
                handleOpen={AccordionState.booking.handleOpen}
            >
                <BookingForm isPreview={isPreview} />
            </Accordion>
            <Accordion
                isOpen={AccordionState.payment.isOpen}
                title={AccordionState.payment.title}
                disabled={AccordionState.payment.isDisabled}
                handleOpen={AccordionState.payment.handleOpen}
            >
                <PaymentForm isPreview={isPreview} />
            </Accordion>
            <Accordion
                isOpen={AccordionState.documents.isOpen}
                title={AccordionState.documents.title}
                disabled={AccordionState.documents.isDisabled}
                handleOpen={AccordionState.documents.handleOpen}
            >
                <DocumentsForm isPreview={isPreview} />
            </Accordion>
        </Tab>
    </Tabs>
)
